import useSWR, { type SWRConfiguration } from 'swr';
import fetcher from '@/lib/swr/fetcher';
import type User from '@/types/api/User';
import useOwnerOrgId from '../useOwnerOrgId';

const formatUserGroups = (groupName: string) =>
  groupName ? [{ groupDisplayName: groupName }] : [];

const useUsers = (swrOptions: SWRConfiguration = {}) => {
  const ownerOrgId = useOwnerOrgId();

  const key = ownerOrgId ? `orgs/${ownerOrgId}/users` : null;
  return useSWR<User[]>(
    key,
    async (path) => {
      const res = await fetcher<{ users: User[] }>(path);

      return (res?.users || []).map((userData: User) => ({
        groups: formatUserGroups(userData?.group),
        ...userData,
      }));
    },
    swrOptions,
  );
};

export default useUsers;
